import { useAppointmentFromContext } from 'pages/Appointment';
import { useNoteSetupContext } from 'shared/features/note-setup';
import { formatPostalAddress } from 'shared/utils';
import { useMe } from 'shared/hooks';
import { AppointmentMedium } from 'constants/appointmentMedium';
import { appointmentMethod } from 'constants/ehrNoteEnums';
export var useDefaultNoteMethod = function () {
    var _a, _b;
    var appointment = useAppointmentFromContext();
    var _c = useNoteSetupContext(), noteSetupData = _c.data, noteSetupLoading = _c.isLoading;
    var _d = useMe(), me = _d.data, meLoading = _d.isLoading;
    var memberPostalAddress = (_b = (_a = noteSetupData === null || noteSetupData === void 0 ? void 0 : noteSetupData.appointment) === null || _a === void 0 ? void 0 : _a.member) === null || _b === void 0 ? void 0 : _b.postal_address;
    var formattedMemberAddress = formatPostalAddress(memberPostalAddress);
    var formattedProviderAddress = formatPostalAddress(me === null || me === void 0 ? void 0 : me.care_provider);
    var isLoading = meLoading || noteSetupLoading;
    var isInPerson = appointment.medium === AppointmentMedium.inPerson;
    return isLoading ? null : { method: isInPerson ? appointmentMethod.inPerson : appointmentMethod.telehealth, location: isInPerson ? formattedProviderAddress : formattedMemberAddress };
};
